"use client";

import { useState } from "react";
import VoucherSection from "./VoucherSection";
import SelectedProductSummary from "@/components/SelectedProductSummary";

export default function VoucherSectionClient({ initial }) {
  const [selectedProduct, setSelectedProduct] = useState(null);

  return (
    <>
      <VoucherSection
        initial={initial}
        selectedProduct={selectedProduct}
        onSelect={setSelectedProduct}
      />

      {selectedProduct && (
        <div
                className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4"
                onClick={() => setSelectedProduct(null)}
                >
                <div
                    className="max-h-[90vh] overflow-auto"
                    onClick={(e) => e.stopPropagation()}
                >
                    <SelectedProductSummary
                    product={selectedProduct}
                    onCancel={() => setSelectedProduct(null)}
                    />
                </div>
                </div>
      )}
    </>
  );
}